import Inquiry from "./Inquiry";

const About = () => {
  return (
    <div
      id="about"
      className=" relative w-full h-full px-[calc((100%-var(--container))/2)] 3xl:px-[calc((100%-var(--container)-100px))] py-8 lg:py-16 2xl:py-32"
    >
      <p className="text-[#9E9E9E] mb-10 lg:mb-16">01. 긴급출동 요청</p>
      <div className=" relative w-full h-full grid xl:grid-cols-6 gap-5 lg:gap-10">
        <div className="xl:col-span-2 text-black lg:py-10">
          <h2 className="gmedium font-light leading-8 text-[35px] md:text-[42px] lg:text-[55px] 2xl:mb-1 2xl:text-6xl">
            긴급한&nbsp;상황엔?
          </h2>
          <h2 className="manru text-[35px] md:text-[42px] lg:text-[55px] 2xl:text-6xl font-light">
            <span className="text-[var(--red-color)]">긴급출동</span>
            &nbsp;서비스
          </h2>
        </div>
        <div
          data-aos="fade-left"
          className="xl:col-span-4 relative w-full h-full rounded-3xl bg-white py-10 px-3 lg:px-14"
        >
          <div className="flex items-center justify-between lg:gap-5">
            <div className=" border-l-4 border-primary pl-5 text-black">
              <p className=" 2xl:text-xl">도어락이 갑자기 잠겼거나</p>
              <p className=" 2xl:text-xl my-1">화장실에 갑자기 갇혔거나</p>
              <p className="2xl:text-xl text-[#9E9E9E]">
                지금 당장 도움이 필요하시다면?
              </p>
            </div>
            <div>
              <img
                className="!relative object-contain w-14 xs:w-20 h-auto 2xl:w-32"
                src="/images/iconSiren.png"
                alt="icon"
                width={279}
                height={221}
              />
            </div>
          </div>
          <div>
            <button
              type="button"
              onClick={() => window.open("tel:010-9287-9477")}
              className=" relative w-full h-auto px-4 lg:px-8 3xl:px-10 my-5 3xl:my-8"
            >
              <img
                className=" relative w-full h-auto object-contain"
                src="/images/num.png"
                alt="number"
                width={1189}
                height={107}
              />
            </button>
            <div>
              <Inquiry />
            </div>
          </div>
        </div>
        <div className="relative w-full h-fit xl:absolute xl:w-fit left-0 bottom-5 text-black mt-5 lg:mt-0 ">
          <div className="flex justify-center xl:justify-start items-center gap-2 mb-2">
            <img
              src="/images/iconCheck.png"
              alt="icon"
              width={30}
              height={30}
            />
            <h3 className="font-light lg:text-3xl">전화 및 문자문의 주시면</h3>
          </div>
          <div className="text-center xl:text-left">
            <h3 className="font-light lg:text-3xl">
              <span className="bg-primary text-white w-fit h-fit py-1 px-2 rounded-lg">
                1시간안에
              </span>{" "}
              바로 출동합니다.
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
